import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Cabserviceinpune() {



    const cardData = {

keyword: "Cab Service in Pune",

headingDescription:
    "Rising Cab Service offers reliable and affordable Cab Service in Pune for local travel, airport transfers, railway station drops, corporate commuting, and outstation journeys. We provide well-maintained Sedan, SUV, Innova Crysta, Tempo Traveller, and Urbania vehicles driven by experienced and professional chauffeurs. Our service is available 24/7 with quick booking, on-time pickup, and transparent pricing. Whether you are traveling within Pune city or planning a long-distance trip across Maharashtra and India, Rising Cab Service ensures a safe, comfortable, and hassle-free travel experience.",

topPlaces: [
   
    {
        title: "Sindhudurg Fort",
        description:
            " is a historic sea fort built by Chhatrapati Shivaji Maharaj, located on an island off the Malvan coast. It is known for its architecture, history, and sea views."
    },
    {
        title: "Dapoli",
        description:
            " is a coastal hill station offering beaches, coconut groves, and dolphin-spotting experiences. It combines sea views with a cooler climate, making it a unique Konkan getaway."
    },
    {
        title: "Alibaug",
        description:
            " is a popular beach destination near Mumbai known for forts, clean beaches, ferry rides, and weekend relaxation with seafood and sunset views."
    },
     {
        title: "Ganpatipule",
        description:
            " is a serene coastal town known for its pristine beach and the famous Swayambhu Ganpati Temple. It offers peaceful sea views, clean shores, and a calm spiritual atmosphere ideal for relaxing vacations."
    },
    {
        title: "Tarkarli",
        description:
            " is famous for crystal-clear waters, white sand beaches, and thrilling scuba diving and snorkeling experiences. It is one of the best destinations in Maharashtra for marine adventure tourism."
    },
    {
        title: "Ratnagiri",
        description:
            " is a coastal city known for beaches, mango orchards (Alphonso mangoes), historic forts, and scenic sea cliffs along the Konkan coast."
    },
    {
        title: "Kolhapur",
        description:
            " is a cultural city famous for the Mahalaxmi Temple, Kolhapuri cuisine, leather footwear, and rich Maratha heritage and history."
    },
    {
        title: "Amboli",
        description:
            " is a monsoon hill station in the Sahyadri range known for waterfalls, misty forests, biodiversity, and cool weather, making it a hidden gem in Maharashtra."
    },
    {
        title: "Malvan",
        description:
            " is a coastal town famous for Tarkarli beach nearby, scuba diving, Sindhudurg Fort access, and delicious Malvani seafood cuisine."
    },
    {
        title: "Bhandardara",
        description:
            " is a peaceful lakeside village surrounded by mountains, waterfalls, and Arthur Lake. It is ideal for camping, stargazing, and nature retreats away from city life."
    }
],



services: [
    {
        name: "Best Cab Service in Pune",
        description:
            "Rising Cab Service offers the Best Cab Service in Pune with safe, reliable, and comfortable transportation for local travel, airport transfers, and outstation journeys. We provide well-maintained AC vehicles, professional drivers, 24x7 availability, and transparent pricing to ensure a smooth travel experience for families, corporate clients, and tourists across Pune."
    },
    {
        name: "Top Cab Service Pune",
        description:
            "Our Top Cab Service Pune is designed for passengers who expect premium quality travel with punctual pickups, clean vehicles, and experienced chauffeurs. Rising Cab Service ensures seamless booking, comfortable rides, and dependable service for all types of travel needs including city rides and long-distance trips."
    },
    {
        name: "Reliable Cab Service Pune",
        description:
            "Rising Cab Service provides Reliable Cab Service Pune focused on safety, punctuality, and customer satisfaction. Whether it is daily commuting, airport transfer, or outstation travel, we ensure consistent service quality with trained drivers and well-maintained vehicles."
    },
    {
        name: "Affordable Cab Service Pune",
        description:
            "Book Affordable Cab Service Pune with Rising Cab Service for budget-friendly travel without compromising comfort or safety. We offer competitive pricing, flexible ride options, and transparent fares suitable for daily travel, airport drops, and intercity trips."
    },
    {
        name: "Trusted Cab Service Pune",
        description:
            "Rising Cab Service is a Trusted Cab Service Pune provider known for safe rides, verified drivers, and dependable customer support. We ensure a secure and comfortable travel experience for families, professionals, and tourists."
    },
    {
        name: "Professional Cab Service Pune",
        description:
            "Our Professional Cab Service Pune offers trained drivers, well-maintained vehicles, and disciplined service standards for corporate travel, personal trips, and long-distance journeys across Maharashtra."
    },
    {
        name: "Safe Cab Service Pune",
        description:
            "Rising Cab Service ensures Safe Cab Service Pune with verified drivers, GPS-enabled vehicles, and strict safety standards. We prioritize passenger security for all local and outstation rides."
    },
    {
        name: "AC Cab Service Pune",
        description:
            "Book AC Cab Service Pune for comfortable travel in all weather conditions. Our air-conditioned vehicles are clean, well-maintained, and ideal for city rides, airport transfers, and long-distance journeys."
    },
    {
        name: "Luxury Cab Service Pune",
        description:
            "Rising Cab Service offers Luxury Cab Service Pune with premium vehicles, professional chauffeurs, and high-end travel comfort for special occasions, business travel, and VIP transportation."
    },
    {
        name: "Local Cab Service Pune",
        description:
            "Our Local Cab Service Pune provides quick and convenient transportation within the city for daily commuting, shopping, meetings, and short-distance travel with affordable pricing and fast response time."
    },
    {
        name: "Outstation Cab Service Pune",
        description:
            "Rising Cab Service provides Outstation Cab Service Pune for long-distance travel to destinations like Mumbai, Goa, Shirdi, Nashik, Mahabaleshwar, Kolhapur, and more with safe driving, flexible booking, and comfortable rides."
    },
    {
        name: "Corporate Cab Service Pune",
        description:
            "Book Corporate Cab Service Pune for employee transportation, business travel, and office commuting. We offer punctual service, professional drivers, and organized travel solutions for companies and IT professionals."
    },
    {
        name: "Premium Cab Service Pune",
        description:
            "Rising Cab Service delivers Premium Cab Service Pune with high-quality vehicles, smooth rides, and superior customer experience suitable for business executives and premium travelers."
    },
    {
        name: "Cheapest Cab Service Pune",
        description:
            "Our Cheapest Cab Service Pune provides economical travel options without compromising safety and comfort, making it ideal for budget-conscious passengers and daily commuters."
    },
    {
        name: "Highly Rated Cab Pune",
        description:
            "Rising Cab Service is a Highly Rated Cab Pune provider trusted by thousands of customers for consistent service quality, punctuality, and safe travel experiences across Maharashtra."
    },
    {
        name: "Best Cab Service in Pune to Mumbai",
        description:
            "We offer the Best Cab Service in Pune to Mumbai with comfortable long-distance travel, experienced drivers, and flexible one-way and round-trip options for business and leisure trips."
    },
    {
        name: "Best Outstation Cab Service in Pune",
        description:
            "Rising Cab Service provides Best Outstation Cab Service in Pune for safe and comfortable intercity travel with well-maintained vehicles and professional chauffeurs for all major destinations."
    },
    {
        name: "Best Taxi Service in Pune",
        description:
            "Our Best Taxi Service in Pune ensures reliable, safe, and affordable travel solutions for local rides, airport transfers, and outstation journeys with 24x7 availability."
    },
    {
        name: "Best Cab Service Mumbai to Pune",
        description:
            "Rising Cab Service offers Best Cab Service Mumbai to Pune with smooth highway travel, experienced drivers, and comfortable vehicles for one-way and round-trip journeys."
    },
    {
        name: "Best Pune to Mumbai Cab Service",
        description:
            "Book Best Pune to Mumbai Cab Service for fast, safe, and comfortable intercity travel with transparent pricing and professional drivers ensuring a smooth journey."
    },
    {
        name: "Best Mumbai Pune Cab Service",
        description:
            "Our Best Mumbai Pune Cab Service provides reliable intercity transportation with clean vehicles, timely pickups, and experienced chauffeurs for business and leisure travel."
    },
    {
        name: "Round Trip Taxi Booking",
        description:
            "Rising Cab Service offers Round Trip Taxi Booking for flexible travel plans with waiting options, return journey convenience, and affordable pricing for intercity routes."
    },
    {
        name: "Round Trip Cab Rental",
        description:
            "Book Round Trip Cab Rental with Rising Cab Service for complete travel solutions including pickup, drop, waiting time, and return journey with comfort and reliability."
    },
    {
        name: "Intercity Round Trip Cab",
        description:
            "Our Intercity Round Trip Cab service ensures safe and comfortable travel between cities with flexible scheduling, professional drivers, and well-maintained vehicles."
    },
    {
        name: "Outstation Cab Round Trip",
        description:
            "Rising Cab Service provides Outstation Cab Round Trip options for long-distance travel with return flexibility, making it ideal for family trips and business travel."
    },
    {
        name: "Round Trip Airport Taxi",
        description:
            "Book Round Trip Airport Taxi for stress-free airport transfers with pickup and drop service, ensuring timely travel and comfortable rides."
    },
    {
        name: "Round Trip Innova Cab",
        description:
            "Rising Cab Service offers Round Trip Innova Cab for group and family travel with spacious seating, comfort, and reliable long-distance transportation."
    },
    {
        name: "Long Distance Taxi Service",
        description:
            "Our Long Distance Taxi Service ensures safe, comfortable, and affordable intercity travel across Maharashtra and India with professional drivers and well-maintained vehicles."
    },
    {
        name: "Round Trip Travel Cab",
        description:
            "Rising Cab Service provides Round Trip Travel Cab for flexible travel planning with return journey convenience and smooth transportation experience."
    },
    {
        name: "24x7 Cab Service Pune",
        description:
            "Book 24x7 Cab Service Pune with Rising Cab Service for round-the-clock availability, quick response, and reliable transportation anytime you need."
    },
    {
        name: "Online Cab Booking Pune",
        description:
            "Our Online Cab Booking Pune system allows instant cab reservations with transparent pricing, multiple vehicle options, and quick confirmation for all travel needs."
    },
    {
        name: "Local Cab Service in Pune",
        description:
            "Rising Cab Service offers Local Cab Service in Pune for daily commuting, shopping, meetings, and short-distance travel with affordable and quick service."
    },
    {
        name: "Outstation Cab Service Pune",
        description:
            "We provide Outstation Cab Service Pune for safe intercity travel to popular destinations with experienced drivers and comfortable vehicles."
    },
    {
        name: "Pune Airport Cab Service",
        description:
            "Rising Cab Service offers Pune Airport Cab Service with timely pickups, drop-offs, and 24x7 availability for stress-free airport transfers."
    },
    {
        name: "Safe Taxi Service Pune",
        description:
            "Our Safe Taxi Service Pune ensures passenger safety with verified drivers, GPS tracking, and well-maintained vehicles for all types of travel."
    },
    {
        name: "Cheap Cab Booking Pune",
        description:
            "Book Cheap Cab Booking Pune with Rising Cab Service for affordable travel solutions without compromising safety, comfort, or reliability."
    }
],

tableData: [
    ["Best Cab Service in Pune", "Top Cab Service Pune"],
    ["Reliable Cab Service Pune", "Affordable Cab Service Pune"],
    ["Trusted Cab Service Pune", "Professional Cab Service Pune"],
    ["Safe Cab Service Pune", "AC Cab Service Pune"],
    ["Luxury Cab Service Pune", "Local Cab Service Pune"],
    ["Outstation Cab Service Pune", "Corporate Cab Service Pune"],
    ["Premium Cab Service Pune", "Cheapest Cab Service Pune"],
    ["Highly Rated Cab Pune", "Best Cab Service in Pune to Mumbai"],
    ["Best Outstation Cab Service in Pune", "Best Taxi Service in Pune"],
    ["Best Cab Service Mumbai to Pune", "Best Pune to Mumbai Cab Service"],
    ["Best Mumbai Pune Cab Service", "Round Trip Taxi Booking"],
    ["Round Trip Cab Rental", "Intercity Round Trip Cab"],
    ["Outstation Cab Round Trip", "Round Trip Airport Taxi"],
    ["Round Trip Innova Cab", "Long Distance Taxi Service"],
    ["Round Trip Travel Cab", "24x7 Cab Service Pune"],
    ["Online Cab Booking Pune", "Local Cab Service in Pune"],
    ["Outstation Cab Service Pune", "Pune Airport Cab Service"],
    ["Safe Taxi Service Pune", "Cheap Cab Booking Pune"]
],




whychoose: [
    {
        WhyChooseheading: "Complete Travel Solutions Across Pune",
        WhyChoosedescription: "Rising Cab Service offers reliable transportation for local rides, airport transfers, corporate travel, sightseeing tours, railway station pickups, and outstation journeys throughout Pune."
    },
    {
        WhyChooseheading: "Serving Every Corner of the City",
        WhyChoosedescription: "Our cab network covers Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Viman Nagar, Kothrud, Pimpri Chinchwad, Wagholi, Aundh, and all major Pune locations."
    },
    {
        WhyChooseheading: "Vehicles for Every Travel Requirement",
        WhyChoosedescription: "Whether traveling alone or with a large group, customers can choose from Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles."
    },
    {
        WhyChooseheading: "Convenient Airport and Railway Transfers",
        WhyChoosedescription: "We provide timely pickup and drop services for Pune Airport, Pune Railway Station, Shivajinagar Station, and nearby transportation hubs."
    },
    {
        WhyChooseheading: "Flexible Booking for Local and Outstation Trips",
        WhyChoosedescription: "Customers can book one-way rides, round trips, full-day rentals, weekend tours, business travel, and customized travel packages."
    },
    {
        WhyChooseheading: "Travel Assistance for Families and Professionals",
        WhyChoosedescription: "Our cab services are widely used by families, students, working professionals, tourists, senior citizens, and corporate travelers."
    },
    {
        WhyChooseheading: "Clean Vehicles and Courteous Drivers",
        WhyChoosedescription: "Every trip is supported by trained drivers and properly maintained vehicles to ensure a safe and pleasant travel experience."
    },
    {
        WhyChooseheading: "Dependable Service with Transparent Pricing",
        WhyChoosedescription: "Rising Cab Service focuses on punctuality, customer satisfaction, and clear pricing without unnecessary complications."
    }
]
};

const faqData = [
    {
        question: "Which areas in Pune are covered by your cab service?",
        answer: "Our services are available across Pune including Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Aundh, and PCMC areas."
    },
    {
        question: "What types of travel can customers book in Pune?",
        answer: "Customers can book local cabs, airport transfers, railway station pickups, outstation trips, sightseeing tours, and corporate travel services."
    },
    {
        question: "Are airport pickups available at any time of day?",
        answer: "Yes, airport transportation can be scheduled according to flight timings, including early morning and late-night travel."
    },
    {
        question: "Can travelers hire vehicles for outstation destinations from Pune?",
        answer: "Yes, cab services are available from Pune to Mumbai, Shirdi, Nashik, Mahabaleshwar, Lonavala, Goa, Kolhapur, and many other destinations."
    },
    {
        question: "Which vehicle categories are most frequently selected?",
        answer: "Sedan cars, Ertiga, Innova Crysta, SUVs, and Tempo Travellers are among the most popular choices."
    },
    {
        question: "Is transportation available for corporate meetings and business visits?",
        answer: "Yes, many professionals and companies use our services for official travel and corporate transportation requirements."
    },
    {
        question: "Can large groups arrange transportation through Rising Cab Service?",
        answer: "Yes, Tempo Travellers and larger vehicles can be arranged for group tours, family events, and corporate outings."
    },
    {
        question: "Do customers have the option to reserve vehicles for an entire day?",
        answer: "Yes, full-day and multi-day bookings are available for personal, business, and sightseeing purposes."
    },
    {
        question: "What advantages does advance booking offer?",
        answer: "Advance reservations help secure preferred vehicle options, especially during weekends, holidays, and peak travel periods."
    },
    {
        question: "How can a cab be reserved in Pune?",
        answer: "Customers can confirm their booking through a phone call, WhatsApp message, or online inquiry with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Amit Bhosale",
        feedback:
            "For both business meetings and airport transfers, Rising Cab Service has consistently provided dependable transportation. The professionalism and punctuality are truly commendable.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Shraddha Kulkarni",
        feedback:
            "A recent family vacation planned through Rising Cab Service turned out wonderfully. Comfortable seating, smooth travel, and excellent coordination made the entire journey enjoyable.",
        rating: 5
    }
];










    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];










const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Cab Service in Pune",
"image": "https://www.risingcabservice.com/assets/images/cab-service-in-pune.jpg",
"description": "Book Cab Service in Pune with Rising Cab Service for local travel, airport transfers, corporate rides, and outstation trips. Enjoy safe, reliable, affordable, and 24/7 taxi service with AC, luxury, and professional drivers.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/cab-service-in-pune"
}
};







    return (
        <div>

<Helmet>
  <title>Cab Service in Pune | Best & Affordable Taxi Service | +91 9272511548</title>

<meta
 name="description"
 content="Book Cab Service in Pune for local travel, airport transfers, and outstation trips. Get safe, reliable, affordable, and professional taxi service with AC and luxury cars available 24/7."
/>

<meta
 name="keywords"
 content="Best cab service in pune, top cab service pune, reliable cab service pune, affordable cab service pune, trusted cab service pune, professional cab service pune, safe cab service pune, ac cab service pune, luxury cab service pune, local cab service pune, outstation cab service pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>



            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/24.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Cabserviceinpune;